import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { AppService } from '../../../../../projects/kiene-core/src/lib/services/app/app.service';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { UserRole } from '../../user/user';
import { VetGroup } from '../../vet-group/vet-group';
import {
    Tierarzt,
    TierarztCreate,
} from '../../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';

@Component({
    selector: 'kiene-combined-benutzer-tierarzt-dialog',
    templateUrl: './combined-benutzer-tierarzt-dialog.component.html',
    styleUrls: ['./combined-benutzer-tierarzt-dialog.component.scss'],
})
export class CombinedBenutzerTierarztDialogComponent implements OnInit {
    tierarztgruppen: VetGroup[] = [];
    newUserFormGroup = new FormGroup({
        titel: new FormControl(''),
        vorname: new FormControl('', [Validators.required]),
        nachname: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl(undefined, [Validators.minLength(8), Validators.required]),
        strasse: new FormControl(''),
        plz: new FormControl(''),
        ort: new FormControl(''),
        tierarztgruppen: new FormControl(undefined, [Validators.required]),
        mobil: new FormControl(),
        festnetz: new FormControl(),
    });
    sendePasswortAnEmailCtrl = new FormControl(true);
    params = new HttpParams().set('lager_id', '3');

    vetParams = new HttpParams().append('tierarzt', '1');

    vetNumberCtrl = new UntypedFormControl();
    qsAliasCtrl = new UntypedFormControl();
    abgabebelegNrCtrl = new UntypedFormControl();

    kennzeichenCtrl = new UntypedFormControl();

    edit = false;
    isSaving = false;

    constructor(
        public dialogRef: MatDialogRef<CombinedBenutzerTierarztDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private api: KieneBackendApiService,
        private appService: AppService,
    ) {}

    ngOnInit(): void {
        const pwd = this.appService.generateKienePassword();
        this.newUserFormGroup.get('password').setValue(pwd);
        this.api.getAll(this.apiBaseUrl + 'tierarztgruppe/read.php').subscribe({
            next: value => {
                this.tierarztgruppen = value.records;
            },
            error: err => {
                this.messageService.errorMessage('Tierarztgruppen konnten nicht abgerufen werden!', err);
            },
        });
    }

    compareBenutzerrolle(r1: UserRole, r2: UserRole) {
        return r1?.benutzerrolle_id === r2.benutzerrolle_id;
    }

    public onCancelClick(): void {
        this.dialogRef.close(null);
    }

    safeAndCloseDialog() {
        this.isSaving = true;
        const tierarzt = new TierarztCreate();
        tierarzt.vorname = this.newUserFormGroup.get('vorname').value;
        tierarzt.nachname = this.newUserFormGroup.get('nachname').value;
        tierarzt.titel = this.newUserFormGroup.get('titel').value;
        tierarzt.email = this.newUserFormGroup.get('email').value;
        tierarzt.passwort = this.newUserFormGroup.get('password').value;
        tierarzt.sende_email = this.sendePasswortAnEmailCtrl.value === true ? 1 : 0;
        tierarzt.strasse = this.newUserFormGroup.get('strasse').value;
        tierarzt.plz = this.newUserFormGroup.get('plz').value;
        tierarzt.ort = this.newUserFormGroup.get('ort').value;
        tierarzt.telefon = this.newUserFormGroup.get('festnetz').value;
        tierarzt.mobil = this.newUserFormGroup.get('mobil').value;
        tierarzt.tierarztnummer = this.vetNumberCtrl.value;
        tierarzt.qs_alias = this.qsAliasCtrl.value;
        tierarzt.abgabebeleg_nr = this.abgabebelegNrCtrl.value;
        tierarzt.tierarztgruppen = this.newUserFormGroup.get('tierarztgruppen').value;
        tierarzt.kennzeichen = this.kennzeichenCtrl.value;

        this.api.post(this.apiBaseUrl + 'tierarzt/create.php', tierarzt).subscribe({
            next: (response: Tierarzt) => {
                this.dialogRef.close(response);
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
                this.isSaving = false;
            },
        });
    }

    public isDisabled(): boolean {
        return !this.newUserFormGroup.valid || !this.kennzeichenCtrl.value || this.isSaving;
    }
}
